import { useTranslation } from "react-i18next";
import OrgFiltersSection from "@/components/Shared/Filters/OrgFiltersSection";
import LoadingIndicator from "@/components/Shared/LoadingIndicator/LoadingIndicator";
import { EMPTY_DEFINITION } from "@/models/ConsultantFilter";
import { useOrganisation, useUpdateOrganisation } from "@/networking/organisation.hooks";
import FilterBuilder from "@/pages/Consultants/components/FilterBuilder";
import { useFilterData } from "@/pages/Consultants/components/useFilterData";

const KonsultfilterPage = () => {
	const { t } = useTranslation();
	const { data: organisation } = useOrganisation();
	const { mutate: updateOrganisation, isLoading: isSaving } = useUpdateOrganisation();
	const { options, competenceTree, isLoading } = useFilterData();

	if (isLoading) return <LoadingIndicator />;

	return (
		<div className="max-w-2xl">
			<OrgFiltersSection
				title={t("ORG_CONSULTANT_FILTERS" as any)}
				description={t("ORG_CONSULTANT_FILTERS_DESC" as any)}
				kbTag="consultant-filters"
				emptyTitle={t("ORG_CONSULTANT_FILTERS_EMPTY_TITLE" as any)}
				emptyDesc={t("ORG_CONSULTANT_FILTERS_EMPTY_DESC" as any)}
				filters={organisation?.consultantFilters ?? []}
				isSaving={isSaving}
				onSave={(next) => updateOrganisation({ consultantFilters: next } as any)}
				emptyDefinition={EMPTY_DEFINITION}
				renderBuilder={(def, change) => (
					<FilterBuilder
						definition={def}
						onChange={change}
						options={options}
						competenceTree={competenceTree}
					/>
				)}
			/>
		</div>
	);
};

export default KonsultfilterPage;
